import React, { useState, useEffect } from 'react';
import CheckIn from '../../components/CheckIn';
import attention from '../../assets/images/attention.gif'

const AlertNotification = ({ message, hour , minute, icon, celebrate = false, countdownTo = null}) => {
const [isVisible, setIsVisible] = useState(false);
const [hasNotified, setHasNotified] = useState(false);
const large = "font-size:'1rem'"
//const [color, setColor] = useState('bg-yellow-600');
const [color, setColor] = useState('bg-indigo-500');
const [defaultMessage, setDefaultMessage] = useState(null);
const [internetSpeed, setInternetSpeed] = useState(1);
const [countdownText, setCountdownText] = useState(null);

const close = () => {
    setIsVisible(false)
    setHasNotified(true)
}

  
useEffect(() => {

    if (!countdownTo) {
        setCountdownText(null);
        return;
    }

    const parseTarget = (raw) => {
        if (raw instanceof Date) {
            return raw;
        }
        const s = String(raw);
        if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
            return new Date(`${s}T00:00:00`);
        }
        return new Date(s);
    };

    const target = parseTarget(countdownTo);

    const format = (ms) => {
        if (!Number.isFinite(ms) || ms <= 0) {
            return '00d 00h 00m 00s';
        }
        const totalSeconds = Math.floor(ms / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const pad = (n) => String(n).padStart(2, '0');
        return `${pad(days)}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
    };

    const tick = () => {
        const now = new Date();
        const diff = target.getTime() - now.getTime();
        setCountdownText(format(diff));
    };

    tick();
    const id = setInterval(tick, 1000);
    //return () => clearInterval(id);

    const checkTime = () => {
        const now = new Date();
        const hours = now.getHours();
        const minutes = now.getMinutes();
        console.log(hour)
        console.log(minute)

        if (hour === false && minute === false) {
            setIsVisible(true);
            setHasNotified(false);
        }

        if (hours === Number(hour) && minutes === Number(minute) && hasNotified === false) {
            setIsVisible(true);
            //setHasNotified(true);
            const timer = setTimeout(() => {
                setColor('bg-gray-600');
            }, 8000); // 8 seconds delay
    
            return () => clearTimeout(timer);
        }

        

        
    };

    // Initial check
    checkTime();

    if (navigator.connection) {
        console.log(`Effective network type: ${navigator.connection.effectiveType}`);
        console.log(`Downlink Speed: ${navigator.connection.downlink}Mb/s`);
        console.log(`Round Trip Time: ${navigator.connection.rtt}ms`);
        setInternetSpeed(navigator.connection.downlink);
    } else {
        console.log('Navigator Connection API not supported');
    }

    if(internetSpeed < 1 && internetSpeed != 1) {

        setIsVisible(true)
        setDefaultMessage('Poor internet speed detected. You may experience some drag in operation. Try a stronger internet')
    } else {
        //setIsVisible(false)
        setDefaultMessage(null)
    }

    // Set up an interval to check every minute
    const intervalId = setInterval(checkTime, 60000); // 60000ms = 1 minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
}, [countdownTo]);

if (!isVisible) return null;

// return (
//     <div className={`${color} text-black px-4 py-3 rounded relative h-16 flex justify-start transition-colors duration-2000`}role="alert">
//     <img src={attention} width="40" />
//     <p className="block text-lg py-0 text-white px-4 mt-2 ml-0"  >{message}</p>
//     <CheckIn className="mt-2" />
//     <span
//         className="absolute top-0 bottom-0 right-0 px-4 py-3"
//         onClick={() => close(false)}
//         style={{ cursor: 'pointer' }}
//     >
//         <svg
//         className="fill-current h-8 w-6 text-white"
//         role="button"
//         xmlns="http://www.w3.org/2000/svg"
//         viewBox="0 0 20 20"
//         >
//         <title >Close</title>
//         <path d="M14.348 5.652a.5.5 0 00-.707 0L10 9.293 6.357 5.65a.5.5 0 00-.707.707L9.293 10l-3.65 3.643a.5.5 0 00.707.707L10 10.707l3.643 3.65a.5.5 0 00.707-.707L10.707 10l3.65-3.643a.5.5 0 000-.707z" />
//         </svg>
//     </span>
//     </div>
// )

return (
    <div className={`${color} text-black px-4 rounded relative flex items-center justify-center transition-colors duration-2000`} style={{ height: '70px' }} role="alert">
    <style>{`
        @keyframes alertZoomInOut { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.06); } }
        @keyframes cheersBounce { 0%, 100% { transform: translateY(0) rotate(0deg) scale(1); } 50% { transform: translateY(-6px) rotate(-8deg) scale(1.08); } }
        @keyframes cheersWiggle { 0%, 100% { transform: rotate(0deg) scale(1); } 25% { transform: rotate(10deg) scale(1.06); } 75% { transform: rotate(-10deg) scale(1.06); } }
    `}</style>
    {/* {celebrate ? (
        // <span style={{ fontSize: '22px', marginRight: '8px', animation: 'cheersBounce 1.8s ease-in-out infinite' }}>⌛</span>
            <img src={icon? icon: attention} width="40" height="35" style={{ marginRight: '3px' }} />

    ) : null} */}
    <img src={icon? icon: attention} width="40" height="35" style={{ marginRight: '3px' }} />
    <p className="block text-base text-white px-4 text-center" style={{ animation: 'alertZoomInOut 2.8s ease-in-out infinite', transformOrigin: 'center' }}  >{defaultMessage ? defaultMessage : message}
    </p>

     <p>
        {countdownText ? (
            <span className="ml-3 text-red-400 font-extrabold" style={{ fontWeight: 900, fontSize: '30px' }} >
                {countdownText}
            </span>
        ) : null}
    </p>

    {celebrate ? (
        <span style={{ fontSize: '22px', marginLeft: '6px', animation: 'cheersWiggle 1.6s ease-in-out infinite' }}>⌛</span>
    ) : null}
    
    <span
        className="absolute right-0 px-4"
        onClick={() => close(false)}
        style={{ cursor: 'pointer', top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', height: '100%' }}
    >
        <svg
        className="fill-current h-8 w-6 text-white"
        role="button"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        >
        <title >Close</title>
        <path d="M14.348 5.652a.5.5 0 00-.707 0L10 9.293 6.357 5.65a.5.5 0 00-.707.707L9.293 10l-3.65 3.643a.5.5 0 00.707.707L10 10.707l3.643 3.65a.5.5 0 00.707-.707L10.707 10l3.65-3.643a.5.5 0 000-.707z" />
        </svg>
    </span>
    </div>
)
  
  
    
}

 
export default AlertNotification;
